var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/Grid/Grid.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_2 = "";t_2 += "\n<div class=\"Grid\">\n    <div class=\"Grid-pad\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-gutter\"></div>\n    <div class=\"Grid-col\"></div>\n    <div class=\"Grid-pad\"></div>\n</div>\n";
t_2 += runtime.suppressValue((lineno = 28, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_2 += " \n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("Grid");
context.setVariable("Grid", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/Grid/Grid.jinja"] , dependencies)